var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label"},[_c('router-view'),_c('TabBar',{attrs:{"tabData":_vm.tabbarList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }